import { createContext, useContext, type Dispatch, type ReactNode } from 'react';
import type { BrandDraft, DraftAction } from './brandDraft';

/**
 * Brand Setup's draft for the step components (web.md §5.3): the state and its dispatch. The page owns
 * the reducer (useWizardController); this is the stable surface the steps, and Release 4's suggestions
 * and re-read, build on.
 */
export interface BrandDraftContextValue {
  state: BrandDraft;
  dispatch: Dispatch<DraftAction>;
}

const BrandDraftContext = createContext<BrandDraftContextValue | null>(null);

export function BrandDraftProvider({ value, children }: { value: BrandDraftContextValue; children: ReactNode }) {
  return <BrandDraftContext.Provider value={value}>{children}</BrandDraftContext.Provider>;
}

export function useBrandDraft(): BrandDraftContextValue {
  const ctx = useContext(BrandDraftContext);
  if (!ctx) throw new Error('useBrandDraft must be used within <BrandDraftProvider>');
  return ctx;
}
